// import Vue from 'vue';
import * as types from './../type';
// import store from './../index'
const state = {
  get custName() {return localStorage.getItem("custName");},
  get empNo() {return localStorage.getItem("empNo");},
  get empAcct() {return localStorage.getItem("empAcct");},
  get empName() {return localStorage.getItem("empName");},
  get menus() {return localStorage.getItem("menus");},
  get sessionid() {return localStorage.getItem("sessionid");},
  get shopId() {return localStorage.getItem("shopId");},
  get shopName() {return localStorage.getItem("shopName");},
  get custId() {return localStorage.getItem("custId");},
};
const actions = {

};
const mutations = {
  [types.BOSS_LOGIN](state, res) {
    localStorage.setItem("custName", res.custName); //会员名称
    localStorage.setItem("empNo", res.empNo); //登录账号id
    localStorage.setItem("empAcct", res.empAcct); //登录账号
    localStorage.setItem("empName", res.empName);  //登录账号名称
    localStorage.setItem("menus", res.menus); //权限菜单
    localStorage.setItem("sessionid", res.sessionid); //会话id
    localStorage.setItem("shopId", res.shopId); //分店id，0表示总部
    localStorage.setItem("shopName", res.shopName); //分店名称
    localStorage.setItem("custId", res.custId); //商户ID,值=8表示公司自用系统
  },
};
const getters = {

};
export default {
  state,
  actions,
  mutations,
  getters,
}



// WEBPACK FOOTER //
// ./src/vuex/login/login.js